const dark = {
  body: "#181818",
  text: "#ffffff",
};
const light = {
  body: "#ffffff",
  text: "#020202",
};

export { dark, light };
